/** Date, age, and experience helpers for candidate profiles. */

export function formatDateInputValue(value) {
  if (value == null || value === '') return '';
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const y = value.getFullYear();
    const m = String(value.getMonth() + 1).padStart(2, '0');
    const d = String(value.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }
  const s = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function normalizeProfessionalRows(rows) {
  return (Array.isArray(rows) ? rows : []).map(row => ({
    ...row,
    startDate: formatDateInputValue(row?.startDate),
    endDate: formatDateInputValue(row?.endDate)
  }));
}

export function computeAgeFromDob(dob) {
  const iso = formatDateInputValue(dob);
  if (!iso) return null;
  const birth = new Date(`${iso}T12:00:00`);
  if (Number.isNaN(birth.getTime())) return null;
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) age -= 1;
  return age >= 0 && age <= 120 ? age : null;
}

export function formatAgeBadge(dob) {
  const age = computeAgeFromDob(dob);
  return age == null ? '-' : `${age} yrs`;
}

/** Total experience from professional start/end rows (open end = today). */
export function computeExperienceYearsFromProfessional(professional) {
  const rows = normalizeProfessionalRows(professional);
  let totalMonths = 0;
  for (const row of rows) {
    if (!row.startDate) continue;
    const start = new Date(`${row.startDate}T12:00:00`);
    const endIso = row.endDate || formatDateInputValue(new Date());
    const end = new Date(`${endIso}T12:00:00`);
    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || end < start) continue;
    totalMonths +=
      (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
  }
  if (totalMonths <= 0) return null;
  return Math.round((totalMonths / 12) * 10) / 10;
}

export function formatExperienceBadge(professional, fallbackYears) {
  const fromRows = computeExperienceYearsFromProfessional(professional);
  if (fromRows != null) return `${fromRows} yrs exp`;
  const fallback = fallbackYears ?? '';
  if (fallback !== '' && fallback != null && Number.isFinite(Number(fallback))) {
    return `${Number(fallback)} yrs exp`;
  }
  return '-';
}
